import DialogRecherchePersonnePhysique from './DialogRecherchePersonnePhysique';
import DialogRechercheGestionnaire from './DialogRechercheGestionnaire';
import ListInstancesContact from './ListInstancesContact';

export default {
  install(Vue) {
    Vue.component(
      'dialogRecherchePersonnePhysique',
      DialogRecherchePersonnePhysique,
    );
    Vue.component('dialogRechercheGestionnaire', DialogRechercheGestionnaire);
    Vue.component('listInstancesContact', ListInstancesContact);
  },
};
